// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/confluence-search-modal/confluence-search-container/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW","sourcesContent":["._16jlkb7n{flex-grow:1}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
